// Utility functions for working with Ag-Grid

import { BaseExportParams, IRowNode } from 'ag-grid-community';

export class AgUtil {
  /** Circle button for adding a row.  Use with `onCellClicked: (event) => this.addEntity(event.data, event.api)` */
  static addButton(title = '', disabled = false): string {
    return this.iconButton('add_circle', title, disabled);
  }

  /** Circle button for deleting a row.  Use with `onCellClicked: (event) => this.removeEntity(event.data, event.api)` */
  static removeButton(title = '', disabled = false, ensureAlwaysClickable = false): string {
    return this.iconButton('remove_circle', title, disabled, ensureAlwaysClickable);
  }

  static iconButton(icon: string, title = '', disabled = false, ensureAlwaysClickable = false): string {
    return `<button class="color-primary ${
      disabled && ensureAlwaysClickable ? 'active:pointer-events-none' : ''
    }" style="margin-top: 5px" title="${title}" ${
      disabled ? 'disabled' : ''
    }><span class="icon-asset material-icons">${icon}</span></button>`;
  }

  /** Circle button in header for adding a row.  Use with `sortChanged` event to detect click in header. */
  static readonly headerWithAddButton =
    '<div class="ag-cell-label-container" role="presentation">' +
    '<div ref="eLabel" class="ag-header-cell-label" role="presentation" unselectable="on">' +
    '<button class="color-primary" style="margin-top: 5px"><span class="icon-asset material-icons">add_circle</span></button>' +
    '</div></div>';

  /** Get data from params.data, or from child row data if a group row.
   * params is ICellRendererParams, ITooltipParams, etc.
   */
  static getRowData(params: { node?: IRowNode; data?: any }): any {
    if (!params.node?.group) {
      return params.data;
    } else {
      if (params.node?.allLeafChildren.length) {
        return params.node.allLeafChildren[0].data;
      } else {
        return {};
      }
    }
  }

  /** Function to sanitise cells on export to avoid CSV injection attacks.
   * Used in defaultExcelExportParams and defaultCsvExportParams
   */
  static getSanitiseGridExportParams(formatValues?: boolean): BaseExportParams {
    // Regex is reused
    // Not global, and using .test() rather than .exec()
    // So lastIndex doesn't need to be reset after each use
    const dangerChars = /^[\s\+\-=@]/;
    return {
      processCellCallback: (params) => {
        let value = params.value;
        if (formatValues) {
          value = params.formatValue(value);
        }
        if (typeof value === 'string') {
          if (dangerChars.test(value)) {
            value = `'${value}`;
          }
        }
        return value;
      },
    };
  }
}
